module.exports = __webpack_public_path__ + "static/media/chanpin.9c038d24.png";